const filterSelectOptions = (input, option) =>
  option?.label?.toLowerCase().indexOf(input?.toLowerCase()) >= 0

export default filterSelectOptions
